export default {
    user: {
        email: 'Email',
        webs: 'Web pages',
        messengers: 'Messengers',
        welcome: 'Welcome, %(user)s!',
        register: 'Register',
        settings: {
            tables: {
                project_worksheet: {
                    sourceForSys: 'Source of appearance in system'
                }
            }
        }
    },
    profile: {
        privateInfo: {
            title: 'User information',
            about: 'Changing this password implies changing password in Experium software.'
        },
        form: {
            currentPassword:       'Old password',
            newPassword:           'New password',
            passwordRepeat:        'Password confirmation',
            updatePassword:        'Update password',
            passwordChangeSuccess: 'Password has been successfully updated',
            needUpdatePassword:    'To continue, please change you temporary password.'
        },
        avatar: 'Profile photo',
        edit: 'Edit',
        avatar_set: 'Photo uploaded successfully',
        clear: 'Clear',
        save: 'Save photo',
        header_modal: 'Load image',
        upload: 'Click or drag file to this area to upload'
    },
};
